module.exports = __webpack_public_path__ + "img/light_oak_list.0beab9fb.jpg";